import React from "react";

function AdminNavbar() {
  const admin = JSON.parse(
    localStorage.getItem("admin_data")
  );

  const logout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_data");
    window.location.href = "/admin/login";
  };

  return (
    <div
      className="d-flex justify-content-between align-items-center bg-white shadow-sm p-3 rounded"
    >
      <div>
        <h4 className="mb-0">Admin Dashboard</h4>
      </div>

      <div className="d-flex align-items-center gap-3">
        <div>
          <strong>{admin?.full_name}</strong>
          <div style={{ fontSize: "12px", color: "gray" }}>
            {admin?.role}
          </div>
        </div>

        <button
          className="btn btn-danger btn-sm"
          onClick={logout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default AdminNavbar;